import React from "react";
import { navigate, RouteComponentProps } from "@reach/router";
import Table from "ui/Table";
import { PageHeader } from "ui/Header";
import { Entreprise } from "__types__";
import { EntrepriseColumns } from "./data";
import Paper from "ui/Paper";
import axios from "axios";
import "styled-components/macro";
import ActionsGroup from "ui/ActionsGroup";
import { InfoBarContext } from "contexts/InfoBarContext";
import Deletion from "pages/Deletion";

export interface DefaultPageProps extends RouteComponentProps {
  noPageTitle?: boolean;
}

const actions = [
  {
    key: "option_cv_theque",
    label: "Activé l'option CVthèque",
    abilities: ["ADMIN", "MANAGER"],
  },
  {
    key: "remove_option_cv_theque",
    label: "Désactivé l'option CVthèque",
    abilities: ["ADMIN", "MANAGER"],
  },
  { key: "activate", label: "Activer", abilities: ["ADMIN", "MANAGER"] },
  { key: "desactivate", label: "Désactiver", abilities: ["ADMIN", "MANAGER"] },
  {
    key: "resend-email",
    label: "Renvoyer le mail d'activation",
    abilities: ["ADMIN", "MANAGER"],
  },
];

export const Entreprises: React.FC<DefaultPageProps> = () => {
  const [data, setData] = React.useState<Entreprise[]>([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const { setInfo } = React.useContext(InfoBarContext);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [current, setCurrent] = React.useState(null);

  React.useEffect(() => {
    axios("/api/v1/entreprises").then((res) => {
      setData(res.data);
    });
  }, []);

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const setHasCvthequeOption = () => {
    if (selectedRows.length <= 0) {
      return setInfo({
        type: "warning",
        message: "Selectionner les éléments à valider",
      });
    }

    axios
      .put("/api/v1/entreprises/cvtheque/set-option", {
        data: selectedRows,
      })
      .then((res) => {
        setInfo({
          type: "success",
          message: "Option activer avec succès",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
  };

  const removeHasCvthequeOption = () => {
    if (selectedRows.length <= 0) {
      return setInfo({
        type: "warning",
        message: "Selectionner les éléments à desactiver",
      });
    }

    axios
      .put("/api/v1/entreprises/cvtheque/remove-option", {
        data: selectedRows,
      })
      .then((res) => {
        setInfo({
          type: "success",
          message: "Option desactiver avec succès",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
  };

  const resendActivationEmail = () => {
    if (selectedRows.length <= 0)
      return setInfo({
        type: "warning",
        message: "Selectionner les éléments",
      });

    if (selectedRows.length > 10) {
      return setInfo({
        type: "warning",
        message: "Veuillez sélectionner un maximum de 10 entreprises",
      });
    }

    axios
      .post("/api/v1/entreprises/resend-activation-email", {
        data: selectedRows,
      })
      .then((res) => {
        setInfo({
          type: "success",
          message: "Email renvoyé avec succès",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
  };

  const handleAction = (actionKey: string) => {
    switch (actionKey) {
      case "option_cv_theque":
        return setHasCvthequeOption();
      case "remove_option_cv_theque":
        return removeHasCvthequeOption();
      case "activate":
        return activate();
      case "desactivate":
        return desactivate();
      case "resend-email":
        return resendActivationEmail();
    }
  };

  const activate = () => {
    if (selectedRows.length <= 0)
      return setInfo({
        type: "warning",
        message: "Selectionner les éléments",
      });

    axios
      .put("/api/v1/entreprises/activate", {
        data: selectedRows,
      })
      .then((res) => {
        setInfo({
          type: "success",
          message: "Élements activé avec succès",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
  };

  const desactivate = () => {
    if (selectedRows.length <= 0)
      return setInfo({
        type: "warning",
        message: "Selectionner les éléments",
      });

    axios
      .put("/api/v1/entreprises/desactivate", {
        data: selectedRows,
      })
      .then((res) => {
        setInfo({
          type: "success",
          message: "Élements désactivé avec succès",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
  };

  return (
    <>
      <PageHeader title={`Entreprises (${data?.length})`}>
        <ActionsGroup onClick={handleAction} actions={actions} />
      </PageHeader>
      <Paper>
        <Table
          hasSelection
          onRowChecked={setSelectedRows}
          rowsIdentifier="id"
          columns={EntrepriseColumns}
          data={data}
          onRowClick={(row) => {
            navigate("/emplois/entreprises/" + row.id);
          }}
          onRowDelete={(row) => {
            setCurrent(row);
            setOpenDelete(true);
          }}
        />
      </Paper>

      <Deletion
        open={openDelete}
        onClose={handleCloseDelete}
        current={current}
        path="/api/v1/entreprises/"
      />
    </>
  );
};

export default Entreprises;
